import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
export default function Gamessection({ className = "" }) {
  return (
    <div className={`${styles["game-wrapper"]} ${className}`}>
      <div className={`${styles["game-card"]} ${styles["game-card-column"]}`}>
        <Link href="https://games.vikatan.com?pfrom=homepage-mainrow-games">
          <img
            src="https://media.vikatan.com/vikatan/2026-01-08/jg2z3eey/VikatanGamelogo.png?w=200"
            alt="Vikatan Games"
            width="177px"
            height="52px"
          />
        </Link>
      </div>
      <div className={`${styles["game-card"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/dnyoxv3a/VikatanGameSollThedal.png?w=300"
          alt="solthedal"
          width="126px"
          height="23px"
        />
        <Link href="https://games.vikatan.com/solthedal?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={`${styles["game-card"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/0fzyx0hq/VikatanGameMaraisoll.png?w=300"
          alt="Flip Game"
          width="124px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/letter-flip?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/vfee9eun/VikatanGameSolliyadi.png?w=300"
          alt="சொல்லியடி"
          width="115px"
          height="38px"
        />
        <Link href="https://solliyadi.vikatan.com?pfrom=homepage-mainrow-games" className={styles["cta-btn"]} target="">
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/5k8ipobs/VikatanGameSollVettai.png?w=300"
          alt="சொல் வேட்டை"
          width="104px"
          height="38px"
        />
        <Link href="https://games.vikatan.com/word-search?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/s15tk7wu/VikatanGameVarthaiyoduVilaiyadu.png?w=300"
          alt="வார்த்தையோடு விளையாடு"
          width="143px"
          height="38px"
        />
        <Link
          href="https://games.vikatan.com/varthaiyodu-vilaiyadu?pfrom=homepage-mainrow-games"
          className={styles["cta-btn"]}
        >
          Play Now
        </Link>
      </div>

      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/5wxasdev/VikatanGame2048.png?w=300"
          alt="2048"
          width="116px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/2048?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/t2zl1nwi/VikatanGameWatchout.png?w=300"
          alt="Watch Out"
          width="125px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/watchout?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={styles["game-card"]}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/6rnax1om/VikatanGameSudokupuzzle.png?w=300"
          alt="sudoku"
          width="136px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/sudoku?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      <div className={`${styles["game-card"]} ${styles["game-card-column"]} ${styles["game-card-grid"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2026-01-08/2ve9z6s9/VikatanGameSollValam.png?w=300"
          alt="sudoku"
          width="92px"
          height="30px"
        />
        <Link href="https://games.vikatan.com/word-coach?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div>
      {/* <div className={`${styles["game-card-column"]} ${styles["game-card-grid"]}`}>
        <img
          src="https://media.vikatan.com/vikatan/2025-12-06/vmkmyapx/VikatanSolThedallogo.png?w=300"
          alt="sudoku"
          width="92px"
          height="22px"
        />
        <Link href="https://games.vikatan.com/solthedal?pfrom=homepage-mainrow-games" className={styles["cta-btn"]}>
          Play Now
        </Link>
      </div> */}
    </div>
  );
}

Gamessection.propTypes = {
  className: PropTypes.string
};
